import React, { Component } from "react";
import { getMultiLang } from "@platform/api";
import Sidebox from "./index";

export default class WidgetSide extends Component {
    constructor(props) {
        super(props);
        this.state = { json: {} };
    }
    componentWillMount() {
        let callback = json => {
            this.setState({ json });
        };
        getMultiLang({ moduleId: 'base_modal', callback });
    }

    render() {
        const { json } = this.state;
        const { onClose, className } = this.props;
        const customCloseBtn = <span
            className="iconfont icon-guanbi icon-close"
            onClick={onClose}
        />;
        return <Sidebox
            title={json['modal-0001' /* 组件设置 */]}
            show={true}
            mask={false} // 不要遮罩 NCC-244151
            width={240}
            propContainer={document.querySelector('.nc-workbench-container .nc-desktop-setting')} // 这个class依赖于工作桌面
            closeButton={customCloseBtn}
            {...this.props}
            className={`widget-side ${className || ''}`}
        />;
    }
}